<template>
  <div>
    <div class="row">
      <div class="col-8">
        <label for="password" class="control-label">{{ $t('password') }}</label>
        <fg-input
          id="password"
          :placeholder="placeholder"
          v-model="password"
          addon-left-icon="ti ti-lock"
          :type="inputType"
          @input="changePassword()"
        >
        </fg-input>
      </div>
      <div class="col">
        <div class="button-group">
          <div class="position-relative">
            <p-button icon outline @click.native.prevent="generate()" class="tooltipBtn mr-3">
              <i class="ti ti-reload" />
            </p-button>
            <div class="tooltipCustom tooltipCustom--bottom">Reload Password</div>
          </div>
          <div>
            <p-button icon outline @click.native.prevent="copyText(password)" type="success">
              <i class="fas fa-copy" />
            </p-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-8">
        <label for="confirm_password" class="control-label">{{ $t('confirm_password') }}</label>
        <fg-input
          :type="inputType"
          id="confirm_password"
          :placeholder="placeholder"
          v-model="confirm_password"
          addon-left-icon="ti ti-lock"
          @input="changeConfirmPassword()"
        >
        </fg-input>
      </div>
      <div class="col-3">
        <div class="button-group">
          <div v-if="confirm_loading">
            <SvgLoaderMoon class="filterLoadingAnimationIcon" size="20px"> </SvgLoaderMoon>
          </div>
          <div v-if="!confirm_loading && !password_confirmed && confirm_password !== null">
            <p-button type="danger" icon outline>
              <i class="fas fa-times" />
            </p-button>
          </div>
          <div v-if="!confirm_loading && password_confirmed">
            <p-button type="success" icon outline>
              <i class="fas fa-check" />
            </p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgLock from './svg/SvgLock';
import SvgRefresh from './svg/SvgRefresh';
import Copy from './Copy';
import SvgLoaderMoon from './svg/SvgLoaderMoon';
export default {
  name: 'VuePassword',
  components: {
    SvgLoaderMoon,
    SvgLock,
    SvgRefresh,
    Copy,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    size: {
      type: String,
      default: '32',
    },
    characters: {
      type: String,
      default: 'a-z,A-Z,0-9,#',
    },
    placeholder: {
      type: String,
      default: 'Password',
    },
    auto: [String, Boolean],
    value: '',
  },
  data: function () {
    return {
      inputType: null,
      password: null,
      confirm_password: null,
      password_confirmed: false,
      confirm_loading: false,
    };
  },
  mounted: function () {
    if (this.auto === 'true' || this.auto === 1) {
      this.generate();
      this.inputType = this.type;
    } else {
      this.inputType = 'password';
    }
  },
  methods: {
    defineType: function (defaultType = this.inputType) {
      this.inputType = defaultType;
    },
    changePassword: function () {
      this.confirm_password = null;
      this.password_confirmed = false;
      this.defineType('password');
      let passwordWithConfirm = { password: this.password, confirm_password: this.confirm_password };
      console.log(passwordWithConfirm);
      this.$emit('update:field', passwordWithConfirm);
    },
    changeConfirmPassword: function () {
      this.confirm_loading = true;
      let passwordWithConfirm = { password: this.password, confirm_password: this.confirm_password };
      this.$emit('update:field', passwordWithConfirm);
      let vm = this;
      if (this.password === this.confirm_password) {
        this.password_confirmed = true;
        delay(function () {
          vm.confirm_loading = false;
        }, 500);
      } else {
        this.password_confirmed = false;
        delay(function () {
          vm.confirm_loading = false;
        }, 500);
      }
    },
    generate() {
      this.defineType('text');
      let charactersArray = this.characters.split(',');
      let CharacterSet = '';
      let password = '';

      if (charactersArray.indexOf('a-z') >= 0) {
        CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
      }
      if (charactersArray.indexOf('A-Z') >= 0) {
        CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      }
      if (charactersArray.indexOf('0-9') >= 0) {
        CharacterSet += '0123456789';
      }
      if (charactersArray.indexOf('#') >= 0) {
        CharacterSet += '![]{}()%&*$#^<>~@|';
      }

      for (let i = 0; i < this.size; i++) {
        password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
      }
      password += +Math.floor(Math.random() * CharacterSet.length);
      this.password = password;
      this.confirm_password = this.password;
      this.password_not_confirmed = false;
      this.password_confirmed = true;
      let passwordWithConfirm = { password: this.password, confirm_password: this.confirm_password };
      this.$emit('update:field', passwordWithConfirm);
    },
    copyText: function (password) {
      let vm = this;
      this.$copyText(password).then(
        function (e) {
          vm.$notify({
            type: 'success',
            title: vm.$t('Successful'),
            text: vm.$t('password_was_copied'),
          });
        },
        function (e) {
          vm.$notify({
            type: 'danger',
            title: 'Can not copy',
          });
        }
      );
    },
  },
};

let delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
</script>

<style scoped>
.button-group {
  height: 100% !important;
}
</style>
